import React from 'react';

export const LIGHT_PINK_ORANGE = '#FFD8CE';
export const PALE = '#FEF3E5'
export const SOFT_TOMATO = '#E5605E';  